import { render, staticRenderFns } from "./NormalCombobox.vue?vue&type=template&id=63916288&scoped=true&"
import script from "./NormalCombobox.vue?vue&type=script&lang=js&"
export * from "./NormalCombobox.vue?vue&type=script&lang=js&"
import style0 from "./NormalCombobox.vue?vue&type=style&index=0&id=63916288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63916288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
